import { DataType } from "./dataType"

export enum CalculationType {
	Numerical,
	Total,
	Average,
	AddToDate,
	DaysBetweenDates,
	DaysUntilOrFromToday,
	GreaterThan,
	LessThan,
	TimeSpentAs
}

const CalculationDataType: { [key in CalculationType]: string } = {
	[CalculationType.Numerical]: "number",
	[CalculationType.Total]: "number",
	[CalculationType.Average]: "number",
	[CalculationType.AddToDate]: "date",
	[CalculationType.DaysBetweenDates]: "number",
	[CalculationType.DaysUntilOrFromToday]: "number",
	[CalculationType.GreaterThan]: "checkbox",
	[CalculationType.LessThan]: "checkbox",
	[CalculationType.TimeSpentAs]: "time-spent"
}
export default CalculationDataType

export const CalculationDataTypeValue: { [calculationType in CalculationType]: DataType } = {
	[CalculationType.Numerical]: DataType.number,
	[CalculationType.Total]: DataType.number,
	[CalculationType.Average]: DataType.number,
	[CalculationType.AddToDate]: DataType.dateTime,
	[CalculationType.DaysBetweenDates]: DataType.number,
	[CalculationType.DaysUntilOrFromToday]: DataType.number,
	[CalculationType.GreaterThan]: DataType.boolean,
	[CalculationType.LessThan]: DataType.boolean,
	[CalculationType.TimeSpentAs]: DataType.timeSpentAsValue
}

export interface Permission {
	view: any[]
	edit: any[]
}

export interface Permissions {
	record: Permission
	case: Permission
}

export interface Field {
	id?: string;
	title: string;
	description: string | null;
	dataType: string | null;
	dataTypeTitle?: string;

	dataSourceId: string | null;
	dataSourceTitle: string | null;

	definitionId: string | null;
	definitionTitle: string | null;

	allowFiles: boolean;
	displayReadOnly?: boolean

	permissions: Permissions

	added?: boolean;
	add?: boolean;

	extensions?: { [key: string]: any };
}

export interface FieldSelected {
	field: string;
	primitiveDataType: number;
	dataTypeName: string;
}
